import type { Article } from "@/mocks/articles";

export function generateBreadcrumbLD(items: { name: string; url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function generateArticleLD(article: Article) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: article.excerpt,
    author: {
      "@type": "Person",
      name: article.author,
    },
    datePublished: article.publishDate,
    image: article.imageUrl,
    publisher: {
      "@type": "Organization",
      name: "黑料吃瓜网",
      url: "http://cgiqwhk.cn/",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `http://cgiqwhk.cn/article/${article.id}`,
    },
  };
}

export function generateFAQPageLD(faqs: { q: string; a: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  };
}

export function generateOrganizationLD() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑料吃瓜网",
    url: "http://cgiqwhk.cn/",
    description: "黑料吃瓜网官网24小时开放黑料传送门，每日大赛正能量不打烊。聚合全网黑料大全、网红反差八卦与明星黑料。",
    foundingDate: "2024-01-01",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      telephone: "+86-400-000-0000",
      email: "hello@cgiqwhk.cn",
    },
  };
}

export function generateWebPageLD(title: string, url: string, description: string) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    url: url,
    description: description,
    isPartOf: {
      "@type": "WebSite",
      name: "黑料吃瓜网",
      url: "http://cgiqwhk.cn/",
    },
  };
}

export function StructuredData({ data }: { data: object }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}